import { render } from "./TheBody.vue?vue&type=template&id=97d0ca20&scoped=true"
import script from "./TheBody.vue?vue&type=script&lang=js"
export * from "./TheBody.vue?vue&type=script&lang=js"

import "./TheBody.vue?vue&type=style&index=0&id=97d0ca20&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d0ca20"]])

export default __exports__